import AccountBalanceOutlined from '@mui/icons-material/AccountBalanceOutlined';
import AppRegistrationOutlined from '@mui/icons-material/AppRegistrationOutlined';
import BusinessOutlined from '@mui/icons-material/BusinessOutlined';
import CalculateOutlined from '@mui/icons-material/CalculateOutlined';
import CalendarMonthOutlined from '@mui/icons-material/CalendarMonthOutlined';
import ChatOutlined from '@mui/icons-material/ChatOutlined';
import DirectionsCarOutlined from '@mui/icons-material/DirectionsCarOutlined';
import EmailOutlined from '@mui/icons-material/EmailOutlined';
import FiberNewOutlined from '@mui/icons-material/FiberNewOutlined';
import GppGoodOutlined from '@mui/icons-material/GppGoodOutlined';
import GroupsOutlined from '@mui/icons-material/GroupsOutlined';
import HandshakeOutlined from '@mui/icons-material/HandshakeOutlined';
import LocalOfferOutlined from '@mui/icons-material/LocalOfferOutlined';
import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined';
import NotificationsActiveOutlined from '@mui/icons-material/NotificationsActiveOutlined';
import PaymentsOutlined from '@mui/icons-material/PaymentsOutlined';
import PhoneInTalkOutlined from '@mui/icons-material/PhoneInTalkOutlined';
import PlaceOutlined from '@mui/icons-material/PlaceOutlined';
import ReceiptLongOutlined from '@mui/icons-material/ReceiptLongOutlined';
import RequestQuoteOutlined from '@mui/icons-material/RequestQuoteOutlined';
import RouteOutlined from '@mui/icons-material/RouteOutlined';
import ScheduleOutlined from '@mui/icons-material/ScheduleOutlined';
import SearchOutlined from '@mui/icons-material/SearchOutlined';
import SpeedOutlined from '@mui/icons-material/SpeedOutlined';
import SupportAgentOutlined from '@mui/icons-material/SupportAgentOutlined';
import VerifiedOutlined from '@mui/icons-material/VerifiedOutlined';
import VerifiedUserOutlined from '@mui/icons-material/VerifiedUserOutlined';
import { type SvgIconProps } from '@mui/material/SvgIcon';
import type SvgIcon from '@mui/material/SvgIcon';

import { type IconKey } from '@/content/site';

// No piggy-bank / savings imagery anywhere on the site.
const icons: Record<IconKey, typeof SvgIcon> = {
  verified: VerifiedOutlined,
  price: LocalOfferOutlined,
  shield: VerifiedUserOutlined,
  speed: SpeedOutlined,
  payment: PaymentsOutlined,
  route: RouteOutlined,
  tax: ReceiptLongOutlined,
  fraud: GppGoodOutlined,
  updates: NotificationsActiveOutlined,
  email: EmailOutlined,
  newCars: FiberNewOutlined,
  car: DirectionsCarOutlined,
  registration: AppRegistrationOutlined,
  consult: SupportAgentOutlined,
  clearing: LocalShippingOutlined,
  finance: AccountBalanceOutlined,
  quote: RequestQuoteOutlined,
  search: SearchOutlined,
  handshake: HandshakeOutlined,
  calendar: CalendarMonthOutlined,
  chat: ChatOutlined,
  team: GroupsOutlined,
  customer: SupportAgentOutlined,
  building: BusinessOutlined,
  calculator: CalculateOutlined,
  location: PlaceOutlined,
  phone: PhoneInTalkOutlined,
  clock: ScheduleOutlined,
};

/** Decorative: the text beside it always carries the meaning. */
export function ContentIcon({ name, ...rest }: SvgIconProps & { name: IconKey }) {
  const Icon = icons[name];
  return <Icon aria-hidden {...rest} />;
}
